import { Component } from '@angular/core';

import { SpinnerCommunication } from './spinner.communication';

@Component({
  selector: 'spinner',
  templateUrl: 'spinner.component.html',
  standalone: false,
})
export class SpinnerComponent {
  constructor(public spinnerCommunication: SpinnerCommunication) {}
}
